export default __webpack_public_path__ + "static/media/resize.8a9da44d.svg";